<template>
  <div>
    <br />
    <div class v-if="data.data && data.data.length > 0">
      <a href data-toggle="modal" @click="download()">
        <button class="btn btn-outline-brand m-btn m-btn--outline">
          <i class="fas fa-download"></i> Baixar
        </button>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                  style="width: 100%; table-layout: fixed"
                >
                  <thead>
                    <tr>
                      <td
                        nowrap
                        class="text-center align-middle pointer"
                        width="6%"
                        :class="{ 'table-sorted': sortType === 'id' }"
                        @click="sortCall('id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType === 'id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType === 'id' && sortReverse"
                        ></span>
                        <span class="fal fa-sort sort" v-if="sortType != 'id'"></span>
                      </td>
                      <td class="text-center align-middle" width="13%">Cliente</td>
                      <td class="text-center align-middle" width="9%">Documento</td>
                      <td class="text-center align-middle">Plano</td>
                      <td class="text-center align-middle" width="12%">Data</td>
                      <td class="text-center align-middle" width="7%">Qtd Contatos</td>
                      <td class="text-center align-middle" width="12%">Qtd Atendimentos</td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.id"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.name"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          v-model="filters.cnpj"
                        />
                      </td>
                      <td>
                        <SelectPlanTypes
                          :selected="filters.plan"
                          class="form-control form-control-sm m-input"
                          @change="setFilter('plan', $event)"
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    <tr v-for="(customer, id) in data.data" :key="id">
                      <td class="text-center align-middle">{{ customer.id }}</td>
                      <td class="text-left align-middle">
                        {{ customer.name }}
                      </td>
                      <td class="text-center align-middle">
                        {{ customer.cnpj ? customer.cnpj : '-' | cnpj | cpf }}
                      </td>
                      <td class="text-center align-middle">{{ customer.plan }}</td>
                      <td class="text-center align-middle">{{ customer.data | month }}</td>
                      <td class="text-center align-middle">{{ customer.contacts }}</td>
                      <td class="text-center align-middle">{{ customer.attendance }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um total de
                  {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else>Nenhum item a ser exibido.</span>
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = 1">
                        <i class="fal fa-angle-double-left"></i>
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: data.current_page == 1 }">
                      <a class="page-link paginate" @click="page = data.current_page - 1">
                        <i class="fal fa-angle-left"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 2">{{
                        data.current_page - 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a class="page-link paginate" @click="page = data.current_page - 1">{{
                        data.current_page - 1
                      }}</a>
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">{{ data.current_page }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">{{
                        data.current_page + 1
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page + 1 == data.last_page }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 2">{{
                        data.current_page + 2
                      }}</a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.current_page + 1">
                        <i class="fal fa-angle-right"></i>
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a class="page-link paginate" @click="page = data.last_page">
                        <i class="fal fa-angle-double-right"></i>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <CustomerModal v-if="showCustomerSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div
          class="m-quick-sidebar-overlay"
          v-if="showCustomerSave"
          @click="closeSaveContract()"
        ></div>
      </transition>
    </div>
  </div>
</template>

<script>
import CustomerModal from '@/components/customers/CustomerModal';
import SelectCustomerStatuses from '@/components/forms/SelectCustomerStatuses';
import SelectPlanTypes from '@/components/forms/SelectPlanTypes';
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'ReportCustomerAttendanceProtocol',
  props: ['start', 'finish'],
  components: { CustomerModal, SelectCustomerStatuses, SelectInvoiceBillingMonth, SelectPlanTypes },
  data() {
    return {
      data: {},
      sortType: localStorage.customerAttendanceProtocolSortType
        ? localStorage.customerAttendanceProtocolSortType
        : 'id',
      sortReverse: localStorage.customerAttendanceProtocolSortReverse
        ? localStorage.customerAttendanceProtocolSortReverse
        : false,
      amount: localStorage.customerAttendanceProtocolDataAmount
        ? localStorage.customerAttendanceProtocolDataAmount
        : 100,
      page: localStorage.customerAttendanceProtocolDataPage
        ? localStorage.customerAttendanceProtocolDataPage
        : 1,
      filters: {
        id: localStorage.customerAttendanceProtocolFilterId
          ? localStorage.customerAttendanceProtocolFilterId
          : '',
        name: localStorage.customerAttendanceProtocolFilterName
          ? localStorage.customerAttendanceProtocolFilterName
          : '',
        cnpj: localStorage.customerAttendanceProtocolFilterCnpj
          ? localStorage.customerAttendanceProtocolFilterCnpj
          : '',
        plan: localStorage.customerAttendanceProtocolFilterPlan
          ? localStorage.customerAttendanceProtocolFilterPlan
          : '',
      },
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showCustomerSave() {
      return this.$store.state.showCustomerSave;
    },
  },
  methods: {
    clearAlert() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      };
    },
    download() {
      const url = `${baseApiUrl}/v1/customer/download/attendance-protocol${this.convertFilters()}`;
      axios
        .get(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', data);

          let fileName = `relatorio_clientes_contatos_atendimento`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generate() {
      this.alert = {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: 'Gerando o relatório...',
        reason: '',
      };
      this.callData();
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.cnpj = '';
      this.filters.status = '';
      this.filters.plan = '';
      this.filters.sortType = 'id';
      this.filters.sortReverse = false;
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('customerAttendanceProtocolFilterId', this.filters.id);
      localStorage.setItem('customerAttendanceProtocolFilterName', this.filters.name);
      localStorage.setItem('customerAttendanceProtocolFilterCnpj', this.filters.cnpj);
      localStorage.setItem('customerAttendanceProtocolFilterPlan', this.filters.plan);
      localStorage.setItem('customerAttendanceProtocolDataAmount', this.amount);
      localStorage.setItem('customerAttendanceProtocolDataPage', this.page);
      localStorage.setItem('customerAttendanceProtocolSortType', this.sortType);
      localStorage.setItem('customerAttendanceProtocolSortReverse', this.sortReverse);
    },
    convertFilters() {
      const filters = `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&cnpj=${
        this.filters.cnpj ? this.filters.cnpj : ''
      }&plan=${this.filters.plan ? this.filters.plan : ''}&amount=${this.amount}&sortType=${
        this.sortType
      }&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}&start=${this.start}&end=${
        this.finish ? this.finish : this.start
      }`;

      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData() {
      this.data.current_page = 0;
      this.setStorageFilters();
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/search/attendance-protocol/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        this.$emit('updateLoading');
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    window.scroll(0, 0);
  },
};
</script>
